export default "__VITE_ASSET__14174884__"